<script lang="ts">
  // Split section: Sole Craftsmanship & Anti-slip TPR
</script>

<section class="py-16 md:py-24 bg-white border-b border-[#E8E4E0]">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">

      <!-- Left Media (Client Craft/Sole Showcase) -->
      <div class="lg:col-span-6">
        <div class="rounded-2xl overflow-hidden shadow-xl bg-[#F9F6F2] border border-[#E8E4E0] aspect-[4/5] relative">
          <img
            src="/images/client/closupUntitled.png"
            alt="French Toes flexible sole construction and textured anti-slip grip"
            class="w-full h-full object-cover"
            loading="lazy"
            onerror={(e) => {
              (e.currentTarget as HTMLImageElement).src = '/images/client/3stoneUntitled.jpg';
            }}
          />
        </div>
      </div>

      <!-- Right Content -->
      <div class="lg:col-span-6 space-y-6">
        <p class="text-[11px] font-semibold tracking-[0.2em] uppercase text-[#6B6B6B]">The sole story</p>
        <h2 class="font-serif text-3xl sm:text-4xl text-[#1A1A1A] font-normal tracking-tight">Softness you can see</h2>
        <p class="text-sm text-[#6B6B6B] leading-relaxed">
          Every pair starts with a hand-finished last, then a cushioned mid-layer and a flexible outsole that grips without bulk. The result is a shoe that feels broken-in from day one.
        </p>

        <ul class="space-y-4 pt-2">
          <li class="flex items-start gap-3">
            <span class="w-5 h-5 rounded-full bg-[#EBF7F4] text-[#2E8B7A] flex items-center justify-center shrink-0 mt-0.5">
              <svg width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><path d="m4 12 5 5L20 6"/></svg>
            </span>
            <span class="text-xs sm:text-sm text-[#3D3D3D]">
              <b class="text-[#1A1A1A] font-semibold">Anti-slip grip</b> — textured TPR outsole tuned for wet tile, marble and stone floors.
            </span>
          </li>
          <li class="flex items-start gap-3">
            <span class="w-5 h-5 rounded-full bg-[#EBF7F4] text-[#2E8B7A] flex items-center justify-center shrink-0 mt-0.5">
              <svg width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><path d="m4 12 5 5L20 6"/></svg>
            </span>
            <span class="text-xs sm:text-sm text-[#3D3D3D]">
              <b class="text-[#1A1A1A] font-semibold">Breathable lining</b> — soft, sweat-friendly and skin-kind across long wear.
            </span>
          </li>
          <li class="flex items-start gap-3">
            <span class="w-5 h-5 rounded-full bg-[#EBF7F4] text-[#2E8B7A] flex items-center justify-center shrink-0 mt-0.5">
              <svg width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><path d="m4 12 5 5L20 6"/></svg>
            </span>
            <span class="text-xs sm:text-sm text-[#3D3D3D]">
              <b class="text-[#1A1A1A] font-semibold">Vegan-friendly upper</b> — premium hand-feel with kinder materials.
            </span>
          </li>
        </ul>

        <div class="pt-4">
          <a
            href="/shop"
            class="inline-flex items-center gap-2 px-8 py-3.5 rounded-md bg-[#1A1A1A] text-white text-xs font-semibold tracking-wider uppercase hover:bg-black transition-all"
          >
            <span>Shop the collection</span>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M13 6l6 6-6 6"/></svg>
          </a>
        </div>
      </div>

    </div>
  </div>
</section>
